module.exports = __webpack_public_path__ + "img/new_SGS.8391a70.svg";